import { AppTeamUtil } from '../../core/app-team-util';

export class NotificationReportDailyInfo
{
	Date!: Date;
	NumberOfEmailNotifications!: number;
	NumberOfPushNotifications!: number;
	NumberOfSmsNotifications!: number;
	SentUserCountPushNotifications!: number;
	SentUserCountEmailNotifications!: number;
	SentUserCountSmsNotifications!: number;

	constructor(json?: any)
	{
		this.Date = AppTeamUtil.convertApiDateStringToDate(json['Date'])!;
		this.NumberOfEmailNotifications = json.NumberOfEmailNotifications;
		this.NumberOfPushNotifications = json.NumberOfPushNotifications;
		this.NumberOfSmsNotifications = json.NumberOfSmsNotifications;
		this.SentUserCountPushNotifications = json.SentUserCountPushNotifications;
		this.SentUserCountEmailNotifications = json.SentUserCountEmailNotifications;
		this.SentUserCountSmsNotifications = json.SentUserCountSmsNotifications;
	}
}

export class NotificationReportData
{
	DailyInfo!: NotificationReportDailyInfo[];

	constructor(json?: any)
	{
		this.DailyInfo = json.DailyInfo.map((itemJson: any) => new NotificationReportDailyInfo(itemJson));
	}
}
